import {Mapper} from '@s-ui/domain'

export class FromTagToFormattedTagNewsValueObjectMapper extends Mapper {
  constructor({config, newsTagValueObjectFactory}) {
    super()
    this._config = config
    this._newsTagValueObjectFactory = newsTagValueObjectFactory
    this._brands = this._config.get('editorial').SPECIAL_BRANDS
    this._NEED_SPECIAL_FORMAT_TAG_TO_URL = config.get('editorial').NEED_SPECIAL_FORMAT_TAG_TO_URL
  }

  setParams = ({tag}) => {
    this._tag = tag
    return this
  }

  _underScoreTwoSpacedWords(words) {
    words = words.replace(/\s+$/, '-')
    return words.split(' ').join('_')
  }

  _cleanTag({tag}) {
    return tag
      .toLowerCase()
      .replace(/[^a-z0-9À-ú]+$/g, '') // removing any non character at final
      .replace(/\s+/g, ' ') // removing any extra space between words
  }

  _getFixedNameBrand({tag}) {
    return this._brands.reduce(
      (str, brand) => str.replace(brand, this._underScoreTwoSpacedWords),
      this._cleanTag({tag})
    )
  }

  _formatTagToUrl({tag}) {
    const pattern = /([a-z_-]{3,} [a-z0-9]{1} )|([a-z_-]{3,} [a-z0-9]{1})$/g
    const fixedTag = this._getFixedNameBrand({tag})
    const tagFormated = fixedTag.replace(/-+/g, '_')
    const isPatternMatched = pattern.test(tagFormated)
    return isPatternMatched && this._NEED_SPECIAL_FORMAT_TAG_TO_URL
      ? tagFormated.replace(pattern, this._underScoreTwoSpacedWords).replace(/ /g, '-')
      : tagFormated.replace(/ /g, '-')
  }

  map = () =>
    this._newsTagValueObjectFactory({
      tag: this._formatTagToUrl({tag: this._tag})
    })
}
